import { render, staticRenderFns } from "./ChipGroupExperience.vue?vue&type=template&id=5abea508&"
import script from "./ChipGroupExperience.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChipGroupExperience.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5abea508')) {
      api.createRecord('5abea508', component.options)
    } else {
      api.reload('5abea508', component.options)
    }
    module.hot.accept("./ChipGroupExperience.vue?vue&type=template&id=5abea508&", function () {
      api.rerender('5abea508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ChipGroupExperience/ChipGroupExperience.vue"
export default component.exports